import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import './FormCTA.module.css';

class FormCTA extends PureComponent {
  render() {
    const { classes, styles, placeholder, inputScale, buttonText } = this.props;
    return (
      <div styleName="form-cta" className={classes} style={styles}>
        <input
          styleName="cta-input"
          type="text"
          placeholder={placeholder}
          style={{ flex: inputScale }}
        />
        <button styleName="cta-button" type="button">
          {buttonText}
        </button>
      </div>
    );
  }
}

FormCTA.propTypes = {
  placeholder: PropTypes.string,
  inputScale: PropTypes.number,
  buttonText: PropTypes.string,
  classes: PropTypes.any,
  styles: PropTypes.object
};

export default DisplayComponent(FormCTA);
